import {generateCustomHeadersForTracking, generateHeadersByCookieValuesFilterByStartsWith,generateHeadersByCookieValuesFilterByEqual} from '../../common/network/apiUtils';
import {allowedKeysForTolkien, hbAdultCookieKey} from '../../common/network/networkConstants';
import {brandQueryApiUrl} from '../../appConfig';

function BrandApiFactory(storefrontApiClient) {
  const brandApi = {
    getBrandInfo(params) {
      return storefrontApiClient.get(`/brand/${params.brandId}`, {
        headers: generateCustomHeadersForTracking(),
        params,
      });
    },
    getSimilarBrands(params) {
      return storefrontApiClient.get('/similarBrands', {
        headers: generateCustomHeadersForTracking(),
        params,
      });
    },
    getBrandProducts(params, cookies) {
      return storefrontApiClient.get('/brandsearch', {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [hbAdultCookieKey]),
        }
        ,
        params,
      });
    },
    getBrandById(params) {
      return storefrontApiClient.get(`${brandQueryApiUrl}/v1/brand/${params.brandId}`, {
        headers: generateCustomHeadersForTracking(),
        params,
      });
    },
    getBrandByProductBrandName(params) {
      return storefrontApiClient.get(`${brandQueryApiUrl}/v1/brand/product-brand/${params.brandName}`, {
        headers: generateCustomHeadersForTracking(),
        params,
      });
    },
  };

  return brandApi;
}

export default BrandApiFactory;
